import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { ConfigurationPersonnelSampleTypeAssignmentResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-sample-type-assignment/configuration-personnel-sample-type-assignment.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentFormState {
    sampleTypes: CommonSampleTypeResponse[]
    personnelSampleTypeAssignments: ConfigurationPersonnelSampleTypeAssignmentResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentFormState =
    (): ConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentFormState => ({
        sampleTypes: [],
        personnelSampleTypeAssignments: [],
        laboratoryId: store.getters.labId
    })
